import React from 'react';
import Sidebar from '@/components/molecules/Sidebar';
import styles from './Pagebase.module.scss';
import Icon from '@/components/atomics/Icons';
import { Button } from '@/components/atomics';
import DaterangePicker from '@/components/atomics/DaterangePicker';

type PagebaseProps = {
  children: React.ReactNode;
  className?: string;
  onChangeDate?: (e: any) => void;
  onDownload?: () => void;
  title?: string;
};

const className = 'pagebase';

const Pagebase: React.FC<PagebaseProps> = ({ children, className: classNameProps,
  onChangeDate, onDownload, title }) => {
  const [mini, setMini] = React.useState<boolean>(true);

  return (
    <div className={styles[className]} style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar mini={mini} />
      <main style={{ flex: 1 }}>
        <nav className={styles[className + '__header']}>
          <div className={styles[className + '__header__title']}>
            <Icon name="Menu" onClick={() => setMini(!mini)}
              style={{ width: '33px', height: '33px' }} />
            {
              title
            }
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {onChangeDate && <DaterangePicker onChange={onChangeDate} />}
            {onDownload && (
              <Button
                className={styles[className + '__header__button']}
                onClick={onDownload}
              >
                <Icon name="Download" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                Download CSV
              </Button>
            )}
          </div>
        </nav>
        <div className={[styles[className + '__content'], classNameProps].join(' ')}>
          {children}          
        </div>
      </main>
    </div>
  );
};

export default Pagebase;
